const MAX_EDGE = 1800;
const TARGET_QUALITY = 0.82;
const BYPASS_BYTES = 1_500_000;

function extensionForMime(mimeType: string): string {
  if (mimeType === 'image/png') return 'png';
  if (mimeType === 'image/webp') return 'webp';
  return 'jpg';
}

export async function prepareInspectionImage(file: File): Promise<File> {
  if (!file.type.startsWith('image/')) {
    throw new Error('Choose a photo in JPEG, PNG or WebP format.');
  }

  if (file.size <= BYPASS_BYTES) {
    return file;
  }

  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
  const width = Math.max(1, Math.round(bitmap.width * scale));
  const height = Math.max(1, Math.round(bitmap.height * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');
  if (!context) {
    bitmap.close();
    throw new Error('This browser could not prepare the photo for upload.');
  }

  context.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();

  const outputMime = file.type === 'image/png' ? 'image/webp' : file.type;
  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (result) => {
        if (result) resolve(result);
        else reject(new Error('Photo compression failed.'));
      },
      outputMime,
      TARGET_QUALITY,
    );
  });

  const baseName = file.name.replace(/\.[^.]+$/, '') || 'inspection-photo';
  return new File([blob], `${baseName}.${extensionForMime(outputMime)}`, {
    type: outputMime,
    lastModified: Date.now(),
  });
}
